import { useEffect } from 'react'
import { isValid } from 'date-fns'
import classesK from '../../kalkulatori.module.css'
import classes from './oddsCalculator.module.css'

const OddsCalculator = ({
  data = {},
  setData,
  field = 'values',
  labelPrefix = ['Polje'],
  calculation,
  array = false,
  header,
  type = ['number'],
  step = ['0.1'],
  min = ['1'],
  rows = 1,
  setError = () => {},
  onCustomChange,
  lastWide = false,
}) => {
  const getNested = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      const match = part.match(/(\w+)\[(\d+)\]/)
      if (match) {
        const [, arrayName, index] = match
        return acc?.[arrayName]?.[parseInt(index)]
      }
      return acc?.[part]
    }, obj)
  }

  const setNested = (obj, path, value) => {
    const keys = path.split('.')

    const setDeep = (target, keys) => {
      const key = keys[0]
      const match = key.match(/(\w+)\[(\d+)\]/)

      if (match) {
        const [, arrayKey, indexStr] = match
        const index = parseInt(indexStr)

        return {
          ...target,
          [arrayKey]: [
            ...(target[arrayKey] || []).slice(0, index),
            keys.length === 1
              ? value
              : setDeep((target[arrayKey] || [])[index] || {}, keys.slice(1)),
            ...(target[arrayKey] || []).slice(index + 1),
          ],
        }
      } else {
        return {
          ...target,
          [key]:
            keys.length === 1
              ? value
              : setDeep(target[key] || {}, keys.slice(1)),
        }
      }
    }

    return setDeep(obj, keys)
  }

  // Ensure all input props are arrays
  const rawValues = getNested(data, field)
  const values = Array.isArray(rawValues) ? rawValues : []

  useEffect(() => {
    if (calculation) {
      const values = Array.isArray(data[field])
        ? data[field]
        : getNested(data, field) || []
      const result = calculation(values)
      setData((prev) => ({
        ...prev,
        result,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(getNested(data, field))])

  const handleChange = (e, index) => {
    const rawValue = e.target.value
    const minVal = parseFloat(min[index]) || 0
    const inputType = type[index]

    const newValue =
      inputType === 'number'
        ? rawValue === ''
          ? ''
          : parseFloat(rawValue)
        : rawValue

    // Enforce min validation
    if (inputType === 'number' && newValue !== '' && newValue < minVal) {
      return // Don't update state if below min
    }

    setData((prev) => {
      const existing = getNested(prev.values, field)
      if (!Array.isArray(existing)) return prev

      const updated = [...existing]
      updated[index] = newValue

      const newValues = setNested({ ...prev.values }, field, updated)
      return {
        ...prev,
        values: newValues,
      }
    })
  }

  const handleWheel = (e) => {
    if (document.activeElement === e.target) {
      e.target.blur() // Blur the input to prevent scroll changing value
    }
  }

  return (
    <div className={classesK.innerContainer}>
      <div className={classes.wrapper}>
        {header && <span className={classesK.calcButton}>{header}</span>}
        <div
          className={`${classesK.contentRow} ${
            rows === 2
              ? classesK.multiRowTwo
              : rows === 3
              ? classesK.multiRowThree
              : rows === 4
              ? classesK.multiRowFour
              : rows === 5
              ? classesK.multiRowFive
              : rows > 1
              ? classesK.multiRow
              : classesK.defaultRow // Fallback class for invalid or unexpected rows
          } ${lastWide ? classesK.lastWide : ''}`}
        >
          {values?.map((val, index) => {
            const handleValidation = (value, index) => {
              const isInvalid =
                type[index] === 'number' &&
                step[index] &&
                (value % parseFloat(step[index]) !== 0 ||
                  value < parseFloat(min[index]))

              // Check if the last input is being changed
              if (index === values.length - 1) {
                const allFilled = values.every(
                  (val) => val !== '' && val !== null && val !== undefined
                )
                setError(isValid) // Set error if not all inputs are filled
              }
            }

            return (
              <div key={index} className={classesK.oddsContainer}>
                <span>{labelPrefix[index]}</span>

                <input
                  type={type[index]}
                  step={type[index] === 'number' ? step[index] : undefined}
                  min={type[index] === 'number' ? min[index] : undefined}
                  value={val}
                  onChange={(e) => handleChange(e, index)}
                  onBlur={(e) => {
                    handleValidation(e.target.value, index)
                  }}
                  onWheel={handleWheel} // Disable changing value on scroll
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default OddsCalculator
